/*
 * Branded loading-overlay (drie vierkantjes in de huisstijlkleuren) over
 * Searchanise's skeleton-placeholder (#snize_skeleton_results) heen.
 *
 * De overlay is één permanent element, rechtstreeks aan document.body
 * gehangen en enkel via positie/grootte + tonen/verbergen aangestuurd.
 * Hij wordt NOOIT uit de DOM verwijderd of opnieuw aangemaakt zolang de
 * pagina leeft, want Searchanise vervangt de binnenkant van
 * #snize_skeleton_results regelmatig volledig (bv. bij elke
 * filterwijziging) — een kind-element daarvan zou dan telkens vernietigd
 * worden en de CSS-animatie zou steeds opnieuw bij nul beginnen. Door de
 * overlay hier los van te houden blijft de animatie één doorlopende,
 * consistente beweging.
 */
(function () {
  var overlay = null;

  function createOverlay() {
    var el = document.createElement('div');
    el.className = 'snize-loading-overlay';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    for (var i = 0; i < 3; i++) {
      var dot = document.createElement('span');
      dot.className = 'snize-loading-overlay__dot';
      dot.setAttribute('aria-hidden', 'true');
      el.appendChild(dot);
    }

    var srText = document.createElement('span');
    srText.className = 'visually-hidden';
    srText.textContent = 'Laden...';
    el.appendChild(srText);

    document.body.appendChild(el);
    return el;
  }

  function syncOverlay() {
    var skeleton = document.getElementById('snize_skeleton_results');

    if (!skeleton) {
      if (overlay) overlay.style.display = 'none';
      return;
    }

    if (!overlay) overlay = createOverlay();

    var rect = skeleton.getBoundingClientRect();
    overlay.style.display = 'flex';
    overlay.style.top = window.scrollY + rect.top + 'px';
    overlay.style.left = window.scrollX + rect.left + 'px';
    overlay.style.width = rect.width + 'px';
    overlay.style.height = rect.height + 'px';
  }

  var resizeObserver =
    'ResizeObserver' in window
      ? new ResizeObserver(function () {
          syncOverlay();
        })
      : null;

  var mutationObserver = new MutationObserver(function () {
    syncOverlay();

    var skeleton = document.getElementById('snize_skeleton_results');
    if (skeleton && resizeObserver) resizeObserver.observe(skeleton);
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('scroll', syncOverlay, { passive: true });
  window.addEventListener('resize', syncOverlay, { passive: true });

  syncOverlay();
})();
